"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var voyageMessageInfoRequest_1 = require("./voyageMessageInfoRequest");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.InfoSend;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.type);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.systemId);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.name);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.title);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.info1);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        type: messageWriter_sidecar_1.messageWriter.read8(m),
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        systemId: messageWriter_sidecar_1.messageWriter.read32(m),
        name: messageWriter_sidecar_1.messageWriter.readString(m),
        title: messageWriter_sidecar_1.messageWriter.readString(m),
        info1: messageWriter_sidecar_1.messageWriter.readString(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        type: voyageMessageInfoRequest_1.EInfoRequestType.Crew,
        crewId: 120,
        systemId: 435,
        name: 'Tommy mctomson',
        info1: 'some info',
        title: 'testmember',
    };
    messageWriter_sidecar_1.messageWriter.test('info-send', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (!voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
        if (msg.type === voyageMessageInfoRequest_1.EInfoRequestType.Crew) {
            var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
            assert_sidecar_1.assert.notNil(cr);
            cr.info1 = msg.info1;
            cr.title = msg.title;
            cr.name = msg.name;
            cr.requestedInfo = true;
        }
        if (msg.type === voyageMessageInfoRequest_1.EInfoRequestType.System) {
            var sys = voyageTilemap_sidecar_1.voyageTilemap.getSystemById(msg.systemId);
            assert_sidecar_1.assert.notNil(sys.system);
            sys.system.requestedInfo = true;
            sys.system.nickname = msg.name;
        }
    }
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
